import Icon, { BaseIconProps } from '../icons/react-components/Icon'
function MultiMessageIcon({ ...props }: BaseIconProps) {
  return (
    <Icon {...props}>
      <svg
        xmlns="http://www.w3.org/2000/svg"
        fill="none"
        viewBox="0 0 32 32"
        {...props}
      >
        <circle cx={16} cy={16} r={15.5} fill="#E8F3FA" stroke="#DFDFDF" />
        <path
          fill="#fff"
          d="M8 17.5V12c0-.681.667-1.617 1-1.5h7.5c1.5 0 2 1 2 1.5 0 .4 0 1 .5 1.5s4-.718 4 1.5v3c0 1.65-.167 3-.5 3.5l-1 .5-.5 1.5-1.5-2h-6c-1.5 0-1.667-1.667-1.5-2.5H9.5C8 19 8 18 8 17.5"
        />
        <path
          fill="#0F69AF"
          d="M16.962 10c1.323 0 2.335 1.126 2.335 2.438v.55h2.084c1.323 0 2.334 1.126 2.335 2.437v4.482c0 1.216-.87 2.27-2.05 2.418l-.343 1.172-.285.98-.743-.7-1.522-1.431h-5.02c-1.322 0-2.334-1.128-2.334-2.439v-.549H9.335C8.012 19.358 7 18.231 7 16.92v-4.483c0-1.229.89-2.296 2.09-2.424L9.336 10zm-3.208 4.237-.106.006c-.522.057-.979.534-.98 1.182v4.482c0 .691.521 1.189 1.086 1.189h5.515l.18.17.961.902.18-.623.133-.45h.658c.565 0 1.085-.497 1.085-1.188v-4.482c0-.69-.52-1.188-1.085-1.188zM9.335 11.25l-.106.006c-.522.057-.979.534-.979 1.181v4.483c0 .69.52 1.188 1.085 1.188h2.084v-2.683c0-1.23.89-2.296 2.09-2.425l.245-.013h4.293v-.55c0-.69-.52-1.187-1.085-1.187z"
        />
      </svg>
    </Icon>
  )
}
export default MultiMessageIcon
